// @flow

import type { wrappedApiResponseType } from '../apiTypes';
import { hpfetch } from '../util';
import type { transactionSchemaType } from '../../types';

export const getMany: any = () => {
  throw new Error({ detail: 'Not Implemented' });
};

export const getSingle = (
  id: number,
): Promise<wrappedApiResponseType<transactionSchemaType>> =>
  hpfetch(`sales/${id}/schema/`);
